import React, { useEffect, useState } from 'react';
import { DEVICES, useSimulator } from '../../contexts/SimulatorContext';
import { DeviceSimulatorToggle } from './DeviceSimulatorToggle';

export const DeviceSimulatorWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { activeDevice } = useSimulator();
  const device = DEVICES[activeDevice];
  const [scale, setScale] = useState(1);
  const [showAnchors, setShowAnchors] = useState(false);
  
  useEffect(() => {
    const handleResize = () => {
      if (activeDevice === 'desktop') return;
      const ww = window.innerWidth;
      const wh = window.innerHeight;
      
      const dw = device.width + 48; // padding + borders
      const dh = device.height + 48;
      
      const scaleX = ww / dw;
      const scaleY = wh / dh;
      const newScale = Math.min(1, Math.min(scaleX, scaleY));
      setScale(newScale);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [activeDevice, device.width, device.height]);

  if (activeDevice === 'desktop') {
    return (
      <>
        <DeviceSimulatorToggle />
        {children}
      </>
    );
  }

  return (
    <div className="fixed inset-0 bg-neutral-900 flex flex-col items-center justify-center -z-[1]">
      <DeviceSimulatorToggle />
      
      <div className="fixed top-4 right-4 z-[999999]">
        <button 
          onClick={() => setShowAnchors(!showAnchors)}
          className={`px-4 py-2 rounded-full font-bold text-sm shadow-lg transition-colors ${showAnchors ? 'bg-red-600 text-white border-2 border-red-400' : 'bg-slate-800 text-slate-300 border border-slate-600 hover:bg-slate-700'}`}
        >
          {showAnchors ? 'Hide Anchors' : 'Show Anchors'}
        </button>
      </div>

      <div 
         className="relative bg-black rounded-[40px] border-[12px] border-neutral-800 shadow-2xl flex items-center justify-center overflow-hidden"
         style={{ 
           width: device.width, 
           height: device.height,
           transform: `scale(${scale})`
         }}
      >
        {/* The translateZ(0) makes this div the containing block for position: fixed elements inside the app! */}
        <div style={{ width: device.width, height: device.height, position: 'relative', transform: 'translateZ(0)' }} 
             className={showAnchors ? 'debug-anchors-enabled' : ''}
        >
           {children}
        </div>
      </div>
{/* 
      Style injection for debugging anchors visually
*/}
      {showAnchors && (
         <style>{`
           .debug-anchors-enabled [id^="ui-anchor-"] {
             outline: 2px dashed rgba(255, 0, 0, 0.7) !important;
             background: rgba(255, 0, 0, 0.1) !important;
           }
         `}</style>
      )}
    </div>
  );
};
